import { render, staticRenderFns } from "./MessageEmbeds.vue?vue&type=template&id=047966d1&scoped=true&"
import script from "./MessageEmbeds.vue?vue&type=script&lang=js&"
export * from "./MessageEmbeds.vue?vue&type=script&lang=js&"
import style0 from "./MessageEmbeds.vue?vue&type=style&index=0&id=047966d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047966d1",
  null
  
)

export default component.exports